import { render, staticRenderFns } from "./WordDictation.vue?vue&type=template&id=0bd68a6e&scoped=true&"
import script from "./WordDictation.vue?vue&type=script&lang=js&"
export * from "./WordDictation.vue?vue&type=script&lang=js&"
import style0 from "./WordDictation.vue?vue&type=style&index=0&id=0bd68a6e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd68a6e",
  null
  
)

export default component.exports